import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { history } from 'routers/history';
import { signVerifiy } from "api/signVerify";
import services from '@jdh-cargo/services';
import { App } from './App';
import { loginOptions } from './utils';
import jdLoginTools_create_by_team_aris from './utils/login';

if (process.env.REACT_APP_ENV === 'production') {
  services.env('prod');
}
 // 初始化B端预发线上环境
services.useInterceptorsRequest((config: any) => signVerifiy(config))
// 初始化登录状态
jdLoginTools_create_by_team_aris.initLoginState(loginOptions);

ReactDOM.render(
  // <React.StrictMode>
  <Router history={history}>
    <App />
  </Router>,
  // </React.StrictMode>,
  document.getElementById('root'),
);
